import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { WHATSAPP_LINK } from "@/pages/home/constants";

interface LegalLayoutProps {
  title: string;
  updatedAt: string;
  children: ReactNode;
}

export default function LegalLayout({ title, updatedAt, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <header className="bg-primary-950">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-sailboat-line text-primary-950 text-lg" />
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-sm font-bold text-white tracking-tight">Eco Tour</span>
                <span className="font-heading text-[10px] font-light text-accent-300 tracking-wider">
                  Turismo
                </span>
              </span>
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[13px] font-medium text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Voltar ao site
            </Link>
          </div>
        </div>
      </header>

      <main className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-2xl md:text-4xl font-heading font-bold text-primary-900 mb-2 tracking-tight">
            {title}
          </h1>
          <p className="text-xs md:text-sm text-foreground-500 mb-8">Última atualização: {updatedAt}</p>
          <div className="space-y-6 text-sm text-foreground-700 leading-relaxed">{children}</div>

          <div className="mt-12 rounded-xl bg-background-100 border border-background-200/70 p-6">
            <h2 className="font-heading text-base font-bold text-primary-900 mb-2">Ficou com dúvidas?</h2>
            <p className="text-sm text-foreground-600 mb-4">
              Fale com a nossa equipe e teremos prazer em ajudar.
            </p>
            <a
              href={WHATSAPP_LINK}
              data-whatsapp-cta
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-bold bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-base" />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}